import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./ConsolidationReportUIHelpers";

const ConsolidationReportUIContext = createContext();

export function useConsolidationReportUIContext() {
  return useContext(ConsolidationReportUIContext);
}

export const ConsolidationReportUIConsumer =
  ConsolidationReportUIContext.Consumer;

export function ConsolidationReportUIProvider({
  consolidationReportUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initConsolidationReport = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initConsolidationReport,
    newConsolidationReportButtonClick:
      consolidationReportUIEvents.newConsolidationReportButtonClick,
    openEditConsolidationReportPage:
      consolidationReportUIEvents.openEditConsolidationReportPage,
    openConsolidationReportFilePage:
      consolidationReportUIEvents.openConsolidationReportFilePage
  };

  return (
    <ConsolidationReportUIContext.Provider value={value}>
      {children}
    </ConsolidationReportUIContext.Provider>
  );
}
